/**
 * Dropdown footer menu
 */
 var dropdown_footer_menu = function(args) {

  // setup args
  var desktop_min_width = args.desktop_min_width, // match this to $breakpoint-desktop-menu SASS variable
      menu              = args.menu,
      screen_w;

  // validate
  if (!menu) {
    //console.log('Invalid drop-down menu');
    return;
  }

  // mobile check
  if (is_desktop_menu()) {
    return;
  }

  /**
   * Helper: Get all ancestors
   */
  function get_all_ancestors(item, css_class) {

    var result = [];
    var ancestor = item.parentElement;
    while (!ancestor.isEqualNode(menu)) {
      if (ancestor.classList.contains(css_class)) {
        result.push(ancestor);
      }
      ancestor = ancestor.parentElement;
    }
    return result;

  }

  /**
   * Helper: Get closest ancestor
   */
  function get_ancestor(item, css_class) {

    var result = get_all_ancestors(item, css_class);
    if (result.length) {
      return result[0];
    }
    return null;

  }

  /**
   * Helper: Is desktop menu
   *
   * Checks if window is wider than set desktop limit.
   *
   * @return bool is desktop width screen
   */
  function is_desktop_menu() {

    screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (screen_w < desktop_min_width) {
      return false;
    }
    return true;

  }

   /**
    * Helper: Show menu item children <section class="widget">
    */
   function activate_menu_item(section) {

    // validate
    if (!section) {
      return;
    }

    // activate <div>
    var div = section.querySelector('div');
    if (div) {
      // activate <li>
      section.setAttribute('aria-expanded', 'true');
      div.setAttribute('aria-hidden', 'false');
    }

  }

   /**
    * Helper: Hide menu item children <section class="widget">
    */
   function deactivate_menu_item(section) {

    // validate
    if (!section) {
      return;
    }

    // deactivate <div>
    var div = section.querySelector('div');
    if (div) {
      // deactivate <div>
      section.setAttribute('aria-expanded', 'false');

      div.setAttribute('aria-hidden', 'true');
    }

  }

  /**
   * Helper: Toggle menu item
   */
     function toggle_menu_item(section) {

      //console.log(section);

      if (section) {
        if (section.getAttribute('aria-expanded') === 'false') {
          activate_menu_item(section);
        } else {
          deactivate_menu_item(section);
        }
      }

    }

  /**
   * Helper: Reset all menu-items' state
   */
  function reset_menu_items() {

    var sections = menu.querySelectorAll('section.widget');
    for (var i = 0; i < sections.length; i++) {
      deactivate_menu_item(sections[i]);
    }

  }

  /**
   * Event: Menu item parent a touched
   *
   * In mobile mode, open sub-menu
   */
  function anchor_click_event(e) {

    // activate or deactivate <li>
    toggle_menu_item(get_ancestor(e.currentTarget, 'widget'));

    // don't trigger parent(s)
    e.stopPropagation();

   }

  /**
   * Init
   */
  function init_dropdown_menu() {

    // close all menus
    reset_menu_items();

    // setup touch hooks (parent section h3)
    var menu_item_a = menu.querySelectorAll('section>h3');
    for (var m = 0; m < menu_item_a.length; m++) {
      menu_item_a[m].addEventListener('click', anchor_click_event, {passive: true});
    }

  }
  init_dropdown_menu();

  // make the call chainable
  return this;

};

/**
 * Init dropdown-footer-menu
 */
var dropdown_menu = document.querySelector('.site-footer__menu');
dropdown_footer_menu({
  desktop_min_width: 890,
  menu: dropdown_menu
});
